module.exports = __webpack_public_path__ + "static/media/13.e703c8ed.JPG";